import { render, staticRenderFns } from "./MicrobialTestingofAvWash.vue?vue&type=template&id=5ea63255&scoped=true&"
import script from "./MicrobialTestingofAvWash.vue?vue&type=script&lang=js&"
export * from "./MicrobialTestingofAvWash.vue?vue&type=script&lang=js&"
import style0 from "./MicrobialTestingofAvWash.vue?vue&type=style&index=0&id=5ea63255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea63255",
  null
  
)

export default component.exports